var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconMail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.7706 3.88518C8.25219 3.66946 10.7478 3.66946 13.2294 3.88518L14.425 3.98911C15.2209 4.0583 15.9026 4.53304 16.2558 5.21211C16.301 5.29898 16.2671 5.40417 16.1839 5.45571L11.2233 8.52652C10.1594 9.18513 8.81793 9.19894 7.74069 8.5624L2.74699 5.61158C2.66632 5.5639 2.62928 5.46577 2.66564 5.3794C2.98877 4.61182 3.71522 4.06385 4.575 3.98911L5.7706 3.88518Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.66158 6.94043C2.53811 6.86747 2.38056 6.94599 2.36617 7.08868C2.1653 9.08022 2.21391 11.0906 2.51202 13.073C2.66918 14.1181 3.52213 14.9193 4.575 15.0109L5.7706 15.1148C8.25219 15.3305 10.7478 15.3305 13.2294 15.1148L14.425 15.0109C15.4779 14.9193 16.3308 14.1181 16.488 13.073C16.7948 11.0328 16.8373 8.96303 16.6156 6.91462C16.6001 6.77092 16.4399 6.69385 16.317 6.76993L11.8484 9.53621C10.409 10.4273 8.59401 10.446 7.13657 9.58475L2.66158 6.94043Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMail);
export default __webpack_public_path__ + "static/media/icon-mail.55db653e8f6f7079d5f4a60ad47df989.svg";
export { ForwardRef as ReactComponent };